import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'sz-app-shell',
  templateUrl: './sz-app-shell.component.html',
  styleUrls: ['./sz-app-shell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class SzAppShellComponent {}
